import { postJSON } from "api/base";

const SHARE_ENDPOINT = `v1/shares`;

export type ShareObjectData = {
    //TODO: not sure what else goes in here
    userSocialCredentialId: string;
};

//TODO: not sure what this is
export type ShareObject = unknown;

/**
 * @function Shares an asset to a social network or other destination
 * @param shareId - Id of the share asset
 * @param data - request object
 */
export const shareToVersionedDestination = async (
    shareId: string,
    data: ShareObjectData
): Promise<ShareObject> => {
    return postJSON(`${SHARE_ENDPOINT}/${shareId}/social-media`, data);
};

export const shareToDestination = async (
    shareId: string,
    data: ShareObjectData & { type: string }
): Promise<ShareObject> => {
    return postJSON(`ws/shares/${shareId}/socialmediashare`, data);
};
